/**
 * Swiss date / time formatting helpers.
 *
 * Schweizer Standard: DD.MM.YYYY mit fuehrenden Nullen, Zeit HH:MM (24h).
 * `toLocaleDateString("de-CH")` allein gibt "20.5.2026" (ohne fuehrende Null)
 * — daher hier immer mit `{ day: '2-digit', month: '2-digit', year: 'numeric' }`.
 */

const ensureDate = (v) => {
  if (!v && v !== 0) return null;
  const d = v instanceof Date ? v : new Date(v);
  return isNaN(d.getTime()) ? null : d;
};

/** "20.05.2026" — empty string when input is falsy/invalid. */
export const formatDateCH = (v) => {
  const d = ensureDate(v);
  if (!d) return "";
  return d.toLocaleDateString("de-CH", { day: "2-digit", month: "2-digit", year: "numeric" });
};

/** "20.05.2026, 14:30" */
export const formatDateTimeCH = (v) => {
  const d = ensureDate(v);
  if (!d) return "";
  return d.toLocaleString("de-CH", {
    day: "2-digit", month: "2-digit", year: "numeric",
    hour: "2-digit", minute: "2-digit",
  });
};

/** "14:30" */
export const formatTimeCH = (v) => {
  const d = ensureDate(v);
  if (!d) return "";
  return d.toLocaleTimeString("de-CH", { hour: "2-digit", minute: "2-digit" });
};

/** "Mi., 20. Mai 2026" — verbose long form, German for Switzerland */
export const formatDateLongCH = (v) => {
  const d = ensureDate(v);
  if (!d) return "";
  return d.toLocaleDateString("de-CH", {
    weekday: "short", day: "2-digit", month: "short", year: "numeric",
  });
};
